import React, { useState, useEffect, useMemo } from 'react';
import { useWallets } from 'hooks/wallets.hook';
import * as Icon from 'react-bootstrap-icons';
import { TableBasicClick } from 'components';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import { guid } from 'helpers/formatter';
import { useAddWallet, useDeleteWallet, useUploadToWallet, useEditWallet } from 'hooks/wallets.hook';
import { date } from 'helpers/formatter';

export { Wallet };

function Wallet() {
  const [validated, setValidated] = useState(false);
  const [showAddDialog, setShowAddDialog] = useState(false);
  const [showEditDialog, setShowEditDialog] = useState(false);
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const [uploadfileList, setUploadFileList] = useState([]);
  const [imageVersion, setImageVersion] = useState(0);

  const [selectedWallet, setSelectedWallet] = useState("");
  const [wallets, setWallets] = useState([]);
  const { data: walletsData, error: walletsError, isError: walletsIsError, isLoading: walletsIsLoading } = useWallets();
  useEffect(() => {
    if (walletsData !== undefined) {
      setWallets(walletsData);
    }
  }, [walletsData]);

  const showAddDialogClick = () => {
    setShowAddDialog(true);
  }

  const handleDeleteClose = () => setShowDeleteDialog(false);
  const handleEditWalletClose = () => setShowEditDialog(false);

  const editWalletMutation = useEditWallet();
  const deleteWalletMutation = useDeleteWallet();
  const addWalletMutation = useAddWallet();
  const uploadToWallet = useUploadToWallet();

  const handleDelete = () => {
    deleteWalletMutation.mutate({
      id: selectedWallet.id,
    });
    setShowDeleteDialog(false);
    setShowEditDialog(false);
  };

  const handleAddSubmit = (event) => {
    const form = event.currentTarget;
    let hasUploads = false;
    let timeout = 0;

    if (form.checkValidity() === true) {
      const id = guid();
      let wallet = {
        id: id,
        name: form.formName.value,
        description: form.formDescription.value,
      };

      addWalletMutation.mutate(wallet);

      let formData = new FormData();
      formData.append(`WalletId`, id);
      formData.append(`WalletParentId`, id);
      [...uploadfileList].forEach((file, i) => {
        hasUploads = true;
        formData.append(`Files[${i}].Id`, id);
        formData.append(`Files[${i}].File`, file);
      });
      if (hasUploads) {
        setIsUploading(true);
        uploadToWallet.mutate({
          formData: formData,
          successCb: () => {
            setUploadFileList([]);
            setShowAddDialog(false);
            setValidated(false);
            setIsUploading(false);
          },
          errorCb: () => {
            setIsUploading(false);
          }
        });
      }
      else {
        setShowAddDialog(false);
        setValidated(false);
      }
    }
    else {
      setValidated(true);
    }
    event.preventDefault();
    event.stopPropagation();
  };

  const handleEditSubmit = (event) => {
    const form = event.currentTarget;
    let hasUploads = false;
    let timeout = 0;
    if (form.checkValidity() === true) {
      let wallet = {
        id: selectedWallet.id,
        name: form.formName.value,
        description: form.formDescription.value,
      };

      editWalletMutation.mutate(wallet);

      let formData = new FormData();
      formData.append(`WalletId`, selectedWallet.id);
      formData.append(`WalletParentId`, selectedWallet.id);
      [...uploadfileList].forEach((file, i) => {
        hasUploads = true;
        formData.append(`Files[${i}].Id`, selectedWallet.id);
        formData.append(`Files[${i}].File`, file);
      });

      if (hasUploads) {
        setIsUploading(true);
        uploadToWallet.mutate({
          formData: formData,
          successCb: () => {
            setUploadFileList([]);
            setShowEditDialog(false);
            setIsUploading(false);
            setValidated(false);
            setImageVersion((v) => v + 1);
          },
          errorCb: () => {
            setIsUploading(false);
          }
        });
      }
      else {
        setShowEditDialog(false);
        setValidated(false);
      }
    }
    else {
      setValidated(true);
    }
    event.preventDefault();
    event.stopPropagation();
  };

  const formatTrProps = (state = {}) => {
    return {
      onClick: () => {
        setSelectedWallet(state.original);
        setShowEditDialog(true);
      }
    };
  };
  const columns = useMemo(
    () => [
      {
        Header: "",
        accessor: "id",
        Cell: ({ row }) => (
          <>
            {row.original.photoUrl.length === 0 ? (
              <div className="wallet-img-default"><Icon.CreditCard size={100} /></div>
            ) : (
              <div
                className="wallet-img"
                style={{
                  backgroundImage:
                    "url(" +
                    row.original.photoUrl +
                    (row.original.photoUrl.includes("?") ? "&" : "?") +
                    "v=" +
                    imageVersion +
                    ")",
                }}
              ></div>
            )}
          </>
        ),
        width: "100px"
      },
      {
        Header: "Name",
        accessor: "name",
      }
      ,
      {
        Header: "Information",
        accessor: "description",
      }
    ],
    [imageVersion]
  );

  return (
    <div className='panel'>
      <h1><Icon.Wallet size={40} /> Wallet</h1>
      <p></p>
      <hr></hr>
      <button className='btn btn-primary' onClick={showAddDialogClick}><Icon.Plus size={20} /> Add</button>
      <p></p>
      {wallets && <TableBasicClick responsive columns={columns} data={wallets} formatRowProps={(state) => formatTrProps(state)} />}
      {walletsIsLoading && <div className='text-center'><div className="spinner-border spinner-border-lg"></div></div>}
      {walletsIsError && <div className="text-danger">Error loading wallets: {walletsError.message}</div>}


      <Modal
        size="lg"
        show={showAddDialog}
        onHide={() => { setShowAddDialog(false); }}
        aria-labelledby="modal-add-wallet"
      >
        <Form noValidate validated={validated} onSubmit={handleAddSubmit}>
          <Modal.Header closeButton closeVariant='white'>
            <Modal.Title id="modal-add-wallet">Add to Wallet</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Group className="mb-3" controlId="formFile">
              <Form.Label></Form.Label>
              <Form.Control type="file" accept=".jpg, .png" onChange={(e) => setUploadFileList(e.target.files)} />
            </Form.Group>
            <p></p><hr />
            <Form.Group className="mb-3" controlId="formName">
              <Form.Label>Name</Form.Label>
              <Form.Control required maxLength="50" type="text" placeholder="Enter a name" />
              <Form.Control.Feedback type="invalid">Please enter a name.</Form.Control.Feedback>
            </Form.Group>
            <Form.Group className="mb-3" controlId="formDescription">
              <Form.Label>Information</Form.Label>
              <Form.Control as="textarea" rows={6} maxLength="500" placeholder="Information" />
            </Form.Group>
            {isUploading && <div className='text-center'><div className="spinner-border spinner-border-lg"></div></div>}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="primary" type="submit">Save</Button>&nbsp;
            <Button variant="secondary" type="button" onClick={() => { setShowAddDialog(false); }}>Cancel</Button>
          </Modal.Footer>
        </Form>
      </Modal>

      <Modal
        size="lg"
        show={showEditDialog}
        onHide={() => { setShowEditDialog(false); }}
        aria-labelledby="modal-edit-wallet"
      >
        <Form noValidate validated={validated} onSubmit={handleEditSubmit}>
          <Modal.Header closeButton closeVariant='white'>
            <Modal.Title id="modal-edit-wallet">{selectedWallet.name}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {(selectedWallet && selectedWallet.photoUrl.length < 1) ? (
              <div className="detail-img-default"><Icon.CreditCard size={150} /></div>
            ) : (
              <a href={selectedWallet.photoUrl} target='_blank'><img className="wallet-img-btn" alt={selectedWallet.name} src={selectedWallet.photoUrl + "?v=" + imageVersion} /></a>
            )}
            <Form.Group className="mb-3" controlId="formFile">
              <Form.Label></Form.Label>
              <Form.Control type="file" accept=".jpg, .png" capture="environment" onChange={(e) => setUploadFileList(e.target.files)} />
            </Form.Group>
            <p></p><hr />

            <Form.Group className="mb-3" controlId="formName">
              <Form.Label>Name</Form.Label>
              <Form.Control required maxLength="50" type="text" defaultValue={selectedWallet.name} placeholder="Enter a name" />
              <Form.Control.Feedback type="invalid">Please enter a name.</Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3" controlId="formDescription">
              <Form.Label>Information</Form.Label>
              <Form.Control as="textarea" rows={6} maxLength="500" placeholder="Information" defaultValue={selectedWallet.description} />
            </Form.Group>
            {isUploading && <div className='text-center'><div className="spinner-border spinner-border-lg"></div></div>}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="primary" type="submit">Save</Button>&nbsp;
            <Button variant="secondary" type="button" onClick={handleEditWalletClose}>Cancel</Button>
            <Button variant="danger" className='modal-btn-right' onClick={() => setShowDeleteDialog(true)}>Delete</Button>
            <p className="last-modified">Last Modified: {date(selectedWallet.modified)}</p>
          </Modal.Footer>
        </Form>
      </Modal>

      <Modal
        show={showDeleteDialog}
        onHide={() => setShowDeleteDialog(false)}
        aria-labelledby="modal-delete"
      >
        <Modal.Header closeButton closeVariant='white'>
          <Modal.Title id="modal-delete">Confirm Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Are you sure you would like to delete:</p>
          {showDeleteDialog && <div><p>{selectedWallet.name}</p></div>}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" type="submit" onClick={(handleDelete)}>Yes</Button>&nbsp;
          <Button variant="secondary" type="button" onClick={handleDeleteClose}>No</Button>
          <p className="last-modified">Last Modified: {date(selectedWallet.modified)}</p>
        </Modal.Footer>
      </Modal>
    </div>
  );
}